import { CookieManager, type ServerContext } from './cookieManager';

/**
 * 언어 설정 쿠키 매니저
 * CookieManager 인스턴스를 composition으로 사용
 */
class LanguageCookieManagerClass {
  private readonly cookieManager: CookieManager;

  constructor() {
    this.cookieManager = new CookieManager('zep-quiz-language', {
      maxAge: 60 * 60 * 24 * 365, // 1 year
    });
  }

  /**
   * 언어 설정
   */
  setLanguage(language: string, context?: ServerContext): void {
    this.cookieManager.set(language, context);
  }

  /**
   * 언어 조회
   */
  getLanguage(context?: ServerContext): string | undefined {
    return this.cookieManager.get(context);
  }

  /**
   * 언어 설정 삭제
   */
  clearLanguage(context?: ServerContext): void {
    this.cookieManager.delete(context);
  }
}

// Singleton instance
export const LanguageCookieManager = new LanguageCookieManagerClass();
